import { ERROR_MESSAGE } from '../../services/vgs/loadScripts/error';
import config from '../../util/config';
import { StripeEnv } from '../../util/enums';

const STRIPE_CLIENT_SCRIPT_DOMAIN = 'https://js.stripe.com/v3/';
const scriptExists = (): boolean => {
  try {
    const scripts = document.querySelectorAll<HTMLScriptElement>(
      `script[src^="${STRIPE_CLIENT_SCRIPT_DOMAIN}"]`,
    );
    return scripts.length > 0;
  } catch (e) {
    return false;
  }
};

const appendScript = async (
  scriptName: string,
  windowKeyName: keyof Window,
): Promise<void> => {
  const target = document.head || document.body;

  if (!target) {
    throw new Error(
      ERROR_MESSAGE.UNABLE_TO_FIND('document.head or document.body'),
    );
  }

  const script = document.createElement('script');
  script.src = scriptName;
  script.async = true;
  document.body.appendChild(script);
  await new Promise<void>((resolve, reject) => {
    script.onload = (): void => {
      if (!window[windowKeyName]) {
        reject(ERROR_MESSAGE.IS_UNDEFINED(`${windowKeyName}`));
      }

      resolve();
    };

    script.onerror = (): void => reject(ERROR_MESSAGE.SCRIPT_WAS_NOT_LOADED);
  });
};

const loadScript = async (
  setStripeClient: (value: StripeClientInterface) => void,
  stripeEnv: StripeEnv,
): Promise<void> => {
  if (!scriptExists() || !window.Stripe) {
    await appendScript(STRIPE_CLIENT_SCRIPT_DOMAIN, 'Stripe');
    const { publishableApiKey } = config.stripe(stripeEnv);
    setStripeClient(window.Stripe(publishableApiKey as string));
  }
};

export const loadStripeClientScript = async (
  setStripeClient: (value: StripeClientInterface) => void,
  stripeEnv: StripeEnv,
): Promise<void> => {
  if (typeof window === 'undefined') {
    throw new Error(ERROR_MESSAGE.IS_UNDEFINED('window'));
  }

  await loadScript(setStripeClient, stripeEnv);
};

export const strToUppercase = (str: string): string => {
  return str[0].toUpperCase() + str.slice(1);
};

export type BankAccountRadioProps = {
  type: 'payableOrg' | 'campaign' | 'add' | null;
};
